export enum NotificationStatus{
    Open = 'Open',
    Pending = 'Pending',
    Closed = 'Closed',
    Cancelled = 'Cancelled'
}